'use client';

import { useLayoutEffect } from 'react';
import { useTranslation } from '@/core/i18n';
import { type SupportedLocale } from '@/core/i18n';
import { useLocaleStore } from '@/core/i18n/locale.store';
import { LocaleContext } from '@/core/i18n/locale.context';

export function LocaleLayoutClient({
  children,
  locale,
}: {
  children: React.ReactNode;
  locale: string;
}) {
  const safeLocale = locale as SupportedLocale;

  useLayoutEffect(() => {
    useLocaleStore.getState().setLocale(safeLocale);
  }, [safeLocale]);

  const { dir } = useTranslation();

  return (
    <LocaleContext.Provider value={safeLocale}>
      <div dir={dir} lang={safeLocale}>
        {children}
      </div>
    </LocaleContext.Provider>
  );
}
